import anime from 'animejs/lib/anime.es.js';
// 画面高さ
const windowHeight = window.innerHeight;
// ブロック
const block1 = document.querySelector('#block1');
const block2 = document.querySelector('#block2');
const block3 = document.querySelector('#block3');
const block4 = document.querySelector('#block4');
// ブロック位置情報
const targets = {
  block1: {
    y: block1.offsetTop,
    height: block1.clientHeight,
  },
  block2: {
    y: block2.offsetTop,
    height: block2.clientHeight,
  },
  block3: {
    y: block3.offsetTop,
    height: block3.clientHeight,
  },
  block4: {
    y: block4.offsetTop,
    height: block4.clientHeight,
  },
};
// ブロック出現情報
const targetIndicators = {
  block1: {
    top: targets.block1.y - windowHeight,
    bottom: targets.block1.y + targets.block1.height,
  },
  block2: {
    top: targets.block2.y - windowHeight,
    bottom: targets.block2.y + targets.block2.height,
  },
  block3: {
    top: targets.block3.y - windowHeight,
    bottom: targets.block3.y + targets.block3.height,
  },
  block4: {
    top: targets.block4.y - windowHeight,
    bottom: targets.block4.y + targets.block4.height,
  },
};

/**
 * Calclate ratio
 * @param {Number} top
 * @param {Number} bottom
 * @param {Number} scroll
 * @return {Number}
 */
function calculateRatio(top, bottom, scroll) {
  const topAdjustNum = top * ((bottom - scroll) / bottom);
  return (bottom - scroll + topAdjustNum) / bottom;
}

/**
 * Update position
 * @param {Object} target
 * @param {NUmber} ratio
 * @param {Number} distance
 * @return {void}
 */
function updatePosition(target, ratio, distance) {
  anime({
    targets: target,
    translateY: -(distance - distance * ratio),
  });
}

const ratio = {
  block1: calculateRatio(
      targetIndicators.block1.top,
      targetIndicators.block1.bottom,
      0
  ),
  block2: calculateRatio(
      targetIndicators.block2.top,
      targetIndicators.block2.bottom,
      0
  ),
  block3: calculateRatio(
      targetIndicators.block3.top,
      targetIndicators.block3.bottom,
      0
  ),
  block4: calculateRatio(
      targetIndicators.block4.top,
      targetIndicators.block4.bottom,
      0
  ),
};

console.table(ratio);

window.addEventListener('scroll', () => {
  const scrollAmount = window.pageYOffset;
  const ratio = {
    block1: calculateRatio(
        targetIndicators.block1.top,
        targetIndicators.block1.bottom,
        scrollAmount
    ),
    block2: calculateRatio(
        targetIndicators.block2.top,
        targetIndicators.block2.bottom,
        scrollAmount
    ),
    block3: calculateRatio(
        targetIndicators.block3.top,
        targetIndicators.block3.bottom,
        scrollAmount
    ),
    block4: calculateRatio(
        targetIndicators.block4.top,
        targetIndicators.block4.bottom,
        scrollAmount
    ),
  };
  updatePosition(block1, ratio.block1, 0);
  updatePosition(block2, ratio.block2, 0);
  updatePosition(block3, ratio.block3, 800);
  updatePosition(block4, ratio.block4, 1600);

  console.table(ratio.block3);
});
